var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.535156,
    y: 0.914062,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#070519"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6054 17.4241L20.0454 13.1441C14.2954 10.2641 11.9354 12.6241 14.8154 18.3741L15.6854 20.1141C15.9354 20.6241 15.9354 21.2141 15.6854 21.7241L14.8154 23.4541C11.9354 29.2041 14.2854 31.5641 20.0454 28.6841L28.6054 24.4041C32.4454 22.4841 32.4454 19.3441 28.6054 17.4241ZM25.3754 21.6641H19.9754C19.5654 21.6641 19.2254 21.3241 19.2254 20.9141C19.2254 20.5041 19.5654 20.1641 19.9754 20.1641H25.3754C25.7854 20.1641 26.1254 20.5041 26.1254 20.9141C26.1254 21.3241 25.7854 21.6641 25.3754 21.6641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMsg);
export default __webpack_public_path__ + "static/media/sendMsg.db7fa9e4ae750597d58abba620d23d83.svg";
export { ForwardRef as ReactComponent };